import React from "react"
import PropTypes from "prop-types"
import Layout from "../components/Layout/layout"
import SEO from "../components/seo"
import {
  contactConfirmContainer,
  contactConfirmButtons,
  contactConfirmMessage,
} from "../styles/contactez-nous.module.scss"
import {
  ValidateImage,
  WarningImage,
} from "../styled-components/contact-styled"
import TransitionFade from "../components/transition-fade"
import Ariane from "../components/Ariane/ariane"
import { useBuildData } from "../hooks/use-build-data"

const ContactConfirmation = ({ location, arianeDisplayed }) => {
  const buildInfos = useBuildData().site_settings.display_contact_form
  if (!buildInfos) {
    return null
  }
  return (
    <Layout message="Formulaire de contact">
      <SEO title="Formulaire de contact" />
      {arianeDisplayed && (
        <Ariane pageName="Formulaire de contact" isListing={true} />
      )}
      <div className={contactConfirmContainer}>
        {location.state?.formValidation ? (
          <>
            <ValidateImage aria-hidden={true} />
            <p className={contactConfirmMessage}>
              Message envoyé avec succès !{" "}
            </p>
          </>
        ) : (
          <>
            <WarningImage />
            <p className={contactConfirmMessage}>
              Un problème est survenu durant l&apos;envoi, veuillez réessayer.
            </p>
          </>
        )}

        <div className={contactConfirmButtons}>
          <TransitionFade className="btn" link="/">
            Retour à l&apos;accueil
          </TransitionFade>
          <TransitionFade className="btn" link="/contactez-nous">
            Retour au formulaire
          </TransitionFade>
        </div>
      </div>
    </Layout>
  )
}

ContactConfirmation.propTypes = {
  location: PropTypes.object,
  arianeDisplayed: PropTypes.bool,
}

export default ContactConfirmation
